/**
 * Centralized Query Keys for TanStack Query
 *
 * All query keys for React Query are defined here for consistency and reusability.
 * This prevents key duplication and makes cache management easier.
 *
 * NOTE: Admin-specific query keys live in src/features/admin/hooks/queryKeys.ts
 * to respect the feature boundary rule (shared/ must not import from features/).
 */

/**
 * Auth-related query keys
 */
export const authQueryKeys = {
  currentUser: ['auth', 'currentUser'] as const,
};

/**
 * Chat-related query keys
 */
export const chatQueryKeys = {
  all: ['chat'] as const,
  messages: (sessionId: string) => ['chat', 'messages', sessionId] as const,
  session: ['chat', 'session'] as const,
};

/**
 * Journal-related query keys
 */
export const journalQueryKeys = {
  sessions: ['journal', 'sessions'] as const,
  journals: ['journal', 'journals'] as const,
  currentSession: ['journal', 'currentSession'] as const,
};

/**
 * Location-related query keys
 */
export const locationQueryKeys = {
  countries: ['location', 'countries'] as const,
  states: (countryCode: string) => ['location', 'states', countryCode] as const,
};

/**
 * Session list-related query keys
 */
export const sessionQueryKeys = {
  list: ['sessions', 'list'] as const,
};

/**
 * Disclosure-related query keys
 */
export const disclosureQueryKeys = {
  humanReview: ['disclosure', 'humanReview'] as const,
};

/**
 * Notification-related query keys
 */
export const notificationQueryKeys = {
  all: ['notifications'] as const,
  list: ['notifications', 'list'] as const,
  infinite: ['notifications', 'infinite'] as const,
};
